module.exports = __webpack_public_path__ + "img/dinkenclave-5.1104e264.jpeg";